import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { IconButton } from '@material-ui/core';
import { SettingsSharp as SettingsIcon } from '@material-ui/icons';
import { useDialogState } from '~/modules/common/hooks';
import EditProjectSettingsDialog from './EditProjectSettingsDialog';

export const ProjectSettingsButton = ({
  projectId,
  projectTeamMemberAssignmentType,
  canEdit
}) => {
  const { formatMessage } = useIntl();
  const { open, openDialog, closeDialog } = useDialogState(false, {
    disabledBackDropClick: true
  });

  if (!canEdit) return null;

  return (
    <>
      <IconButton
        onClick={openDialog}
        aria-label={formatMessage({ id: 'button.projectSettingsEditButton' })}
        data-qe-id="EditProjectSettingsButton"
      >
        <SettingsIcon />
      </IconButton>
      {open && (
        <EditProjectSettingsDialog
          open={open}
          onClose={closeDialog}
          projectId={projectId}
          projectTeamMemberAssignmentType={projectTeamMemberAssignmentType}
        />
      )}
    </>
  );
};

ProjectSettingsButton.propTypes = {
  projectId: PropTypes.string,
  projectTeamMemberAssignmentType: PropTypes.string,
  canEdit: PropTypes.bool
};

export default ProjectSettingsButton;
